import { getProducts, GetFormularyListApiParameter } from "@GeriMed/Services/FormularyListService";
import { CustomerDisplayProductCollection } from "@GeriMed/Type/ApiModelsExt";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";


type HandlerType = ApiHandler<GetFormularyListApiParameter, CustomerDisplayProductCollection>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const DispatchBeginLoadFormularyListList: HandlerType = props => {
    props.dispatch({
        type: "Data/FormularyList/BeginLoadFormularyList" as any,
        parameter: props.parameter,
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getProducts(props.apiParameter);
};
export const DispatchCompleteLoadFormularyListList: HandlerType = props => {
    props.dispatch({
        type: "Data/FormularyList/CompleteLoadFormularyList" as any,
        collection: props.apiResult,
        parameter: props.parameter,
    });
};

export const chain = [
    PopulateApiParameter,
    DispatchBeginLoadFormularyListList,
    RequestDataFromApi,
    DispatchCompleteLoadFormularyListList,
];

const loadFormularyListList = createHandlerChainRunner(chain, "loadFormularyListList");
export default loadFormularyListList;
